import styled from 'styled-components';

export const StyledInterstitialContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  width: 100%;
`;
